import React from 'react';
import ReactPlayer from 'react-player';
import UseModal from 'hooks/use-modal';
import Modal from '@core/components/Modal/Modal';
import { PlayCircle, TickCircle } from 'iconsax-react';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import classes from './CareerPathIntroVideo.module.scss';
import ActionButton from '@core/components/actionbutton/ActionButton';

const CareerPathIntroVideo = ({ videoUrl, thumbnail, bulletHighlights }) => {
    const { show: showVideoModal, showModal: openVideoModal, destroyModal: closeVideoModal } = UseModal();

    if (!videoUrl) return null;

    return (
        <>
            <div className={classes['intro-card']}>
                <span className={classes['watch-first-badge']}>
                    <PlayCircle size={13} color="#578a1d" variant="Outline" />
                    Watch First
                </span>

                <div className={classes['thumbnail']} onClick={openVideoModal} role="button" aria-label="Watch intro video">
                    {thumbnail && <img src={thumbnail} alt="Intro video thumbnail" />}
                    <div className={classes['play-overlay']}>
                        <PlayCircle size={44} color="#fff" variant="Outline" />
                    </div>
                </div>

                <div className={classes['content']}>
                    <p className={classes['label']}>In this video:</p>
                    <div
                        className={classes['bullets']}
                        dangerouslySetInnerHTML={{ __html: bulletHighlights }}
                    />
                </div>

                <ActionButton kind="secondary" onClick={openVideoModal}>
                    Watch Now
                </ActionButton>
            </div>

            <Modal  closeHandler={closeVideoModal} show={showVideoModal} type={MOBILE_SLIDE_UP}>
                <div className={classes['video-player-wrapper']}>
                    <ReactPlayer
                        config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                        url={videoUrl}
                        className="react-player"
                        playing
                        width="100%"
                        height="100%"
                        controls={true}
                    />
                </div>
            </Modal>
        </>
    );
};

export default CareerPathIntroVideo;
